/** Règle RFC-5545 réduite consommée par le scheduler TM (recurrence.go) :
 * FREQ=DAILY|WEEKLY|MONTHLY|YEARLY + INTERVAL=n optionnel. Toute autre clause
 * (BYDAY, UNTIL…) est ignorée par le backend. */
const FREQ_LABEL: Record<string, [string, string]> = {
  DAILY: ["Quotidienne", "jours"],
  WEEKLY: ["Hebdomadaire", "semaines"],
  MONTHLY: ["Mensuelle", "mois"],
  YEARLY: ["Annuelle", "ans"],
};

export function recurrenceLabel(rule: string): string {
  let freq = "DAILY";
  let interval = 1;
  for (const part of rule.split(";")) {
    const [k, v] = part.trim().split("=");
    if (!k || !v) continue;
    if (k.toUpperCase() === "FREQ") freq = v.toUpperCase();
    if (k.toUpperCase() === "INTERVAL") {
      const n = parseInt(v, 10);
      if (n > 0) interval = n;
    }
  }
  const [label, unit] = FREQ_LABEL[freq] ?? FREQ_LABEL.DAILY!;
  return interval === 1 ? label : `Tous les ${interval} ${unit}`;
}
